<template>
  <div>
    <p style="font-size: 16px; line-height: 17px" class="mb-5">※ [<b>{{ $t('위험성평가') }}</b>{{ $t('(유해·위험요인 파악) →') }}<b>{{ $t('위험성평가회의') }}</b>{{ $t('(위험성평가의 공유) →') }}<b>{{ $t('교육·TBM 전파') }}</b>{{ $t('(위험성 결정, 감소대책 수립) →') }}<b>{{ $t('이행확인') }}</b>{{ $t('(감소대책 실행)]') }}</p>
    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" :readonly="board.readonly" />

    <!-- ⑨ 일일TBM 활동 현황 -->
    <TMBTable
      class="mb-6"
      :readonly="!form.stdInfo.field_name || !form.headerDate || board.readonly"
      :prevTmbOption="prevTmbOption"
      :todayTmbOption="todayTmbOption"
      :isPrint="isPrint"
      v-model="form.tmbList"
    />

    <table-custom
      :board="board"
      :is-print="isPrint"
      :title="$t('참석자 명단')"
      :controls="false"
      :multiple="false"
      :tableData="[
        { id: 'target', title: $t('소속명'), type: 'text', placeholder: $t('내용') },
        { id: 'position', title: $t('직급'), type: 'text', placeholder: $t('내용') },
        { id: 'type', title: $t('직책'), type: 'text', placeholder: $t('내용') },
        { id: 'name', title: $t('이름'), type: 'text', placeholder: $t('내용') },
        { id: 'sign', title: $t('서명'), type: 'sign' },
      ]"
      :mobile="['target', 'name']"
      v-model="form.managerList"
    />

    <!--    사진대지-->
    <PhotoUploadGridModule :row-count="2" :grid-count="2" v-model="form.photoList" :isPrint="isPrint" :readonly="board.readonly" section-title="사진대지" placeholder="신축현장 점검" class="mt-28px" />


    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import TMBTable from "./TMBTable.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import FileUploader from "@/components/FileUploader";
import moment from "moment";
import TableCustom from "@/components/TableCustom.vue";

export default {
  components: {
    TableCustom,
    FieldSelectModule,
    FileUploadModule,
    TMBTable,
    DateSelector,
    FileUploader,
  },
  props: {
    isPrint: Boolean,
    header: Object,
    board: Object,
    value: Object,
  },

  data() {
    return {
      form: {
        headerDate: "",
        stdInfo: {},
        fileList: [],
        riskList: [],
        tmbList: [],
        todayTmb: 0,
        managerList: [
          { id: 1, type: "" },
          { id: 2, type: "" },
          { id: 3, type: "" },
          { id: 4, type: "" },
        ],

        inputA_1: "",
        inputA_2: "",
        inputA_3: "",
        inputA_4: "",
        inputA_5: {},
        inputA_6: "",

        photoList: [],
      },
      prevTmbOption: [],
      todayTmbOption: [],

      oldConditions: [],
    };
  },
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
    boardId() {
      return parseInt(this.$route.params.boardId);
    },
    postId() {
      return this.$route.params.postId;
    },
    headerDate() {
      return moment(this.form.headerDate).format("YYYY-MM-DD");
    },
    postList() {
      const _postList = this.$store.state.board.postListInfo.data;
      if (_postList) return _postList.map((post) => this.getContent(post));
      else return [];
    },
  },
  watch: {
    "header": {
      immediate: true,
      deep: true,
      handler(value) {
        const date = value.date;
        this.form.headerDate = date;
      },
    },
    "value": {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    "form": {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        value.todayTmb = value.tmbList.reduce((acc, cur) => acc + Number(cur.input3), 0);
        this.$emit("input", value);
      },
    },
    'form.headerDate': {
      immediate: true,
      handler(value) {
        if (value) {
          this.loadList();
        }
      }
    },
    'form.stdInfo.field_name': {
      immediate: true,
      handler(value) {
        if (value) {
          this.loadList();
        }
      }
    },
  },
  mounted() {
    const buttonContainer = document.querySelector("#right-button-container");
    const loadBtn = this.$refs.loadBtn;
    buttonContainer.prepend(loadBtn.$el);
  },
  methods: {

    translationMap() {
      const prefix = "위험성평가(3등급).일일TBM활동";

      const translateData = {
        [`${prefix}.기본정보.회사명`]: this.form.stdInfo.field_name,
        [`${prefix}.기본정보.작성자이름`]: this.form.stdInfo.writer_name,
        [`${prefix}.기본정보.작성일`]: this.form.stdInfo.date,

        [`${prefix}.위험성평가표`]: this.form.riskList.map((item) => {
          return {
            "공종분류": item.input1,
            "단위작업": item.input2,
            "위험요인": item.input3,
            "재해형태": item.input4,
            "위험성 결정.위험도 등급": item.input5,
            "위험방지대책": item.input6,
            "개선조치 담당자": item.input7,
            "개선조치 조치예정일": item.input8,
            "이행확인.근로자대표": item.input9,
            "이행확인.관리감독자": item.input10,
          }
        }),

        [`${prefix}.위험성 결정, 감소대책 수립 및 실행계획 확인`]: this.form.riskList.map((item) => {
          return {
            "소속명": item.target,
            "직급": item.position,
            "직책": item.type,
            "이름": item.name,
          }
        }),

      };

      if (this.form.tmbList.length > 0) {
        translateData[`${prefix}.일일TBM 활동 현황`] = this.form.tmbList[0].input1
      }

      return translateData;
    },
    translate(translate) {
      const prefix = "위험성평가(3등급).일일TBM활동";
      console.log("translate[`${prefix}.일일TBM 활동 현황`]", translate[`${prefix}.일일TBM 활동 현황`])

      this.form.stdInfo.field_name = translate[`${prefix}.기본정보.회사명`];
      this.form.stdInfo.writer_name = translate[`${prefix}.기본정보.작성자이름`];
      this.form.stdInfo.date = translate[`${prefix}.기본정보.작성일`];
      if (this.form.tmbList.length > 0) {
        this.form.tmbList[0].input1 = translate[`${prefix}.일일TBM 활동 현황`];
      }

      const riskList = translate[`${prefix}.위험성평가표`];
      const _riskList = JSON.parse(JSON.stringify(this.form.riskList));
      for (let i = 0; i<riskList.length; i++) {
        _riskList[i].input1 = riskList[i]['공종분류'];
        _riskList[i].input2 = riskList[i]['단위작업'];
        _riskList[i].input3 = riskList[i]['위험요인'];
        _riskList[i].input4 = riskList[i]['재해형태'];
        _riskList[i].input5 = riskList[i]['위험성 결정.위험도 등급'];
        _riskList[i].input6 = riskList[i]['위험방지대책'];
        _riskList[i].input7 = riskList[i]['개선조치 담당자'];
        _riskList[i].input8 = riskList[i]['개선조치 조치예정일'];
        _riskList[i].input9 = riskList[i]['이행확인.근로자대표'];
        _riskList[i].input10 = riskList[i]['이행확인.관리감독자'];
      }
      this.$set(this.form, "riskList", _riskList);

      const managerList = translate[`${prefix}.위험성 결정, 감소대책 수립 및 실행계획 확인`];
      const _managerList = JSON.parse(JSON.stringify(this.form.riskAppraisalList2));
      for (let i = 0; i<managerList.length; i++) {
        _managerList[i].target = managerList[i]['소속명'];
        _managerList[i].position = managerList[i]['직급'];
        _managerList[i].type = managerList[i]['직책'];
        _managerList[i].name = managerList[i]['이름'];
      }
      this.$set(this.form, "managerList", _managerList);
    },

    // 내용불러오기
    async loadList() {
      if (!this.form.stdInfo.field_name || !this.form.headerDate) return;

      const projectId = this.projectId;
      const boardId = this.boardId;
      const page = 1;
      const perPage = 10000;

      const dateTarget = "body.headerDate";
      const dateBegin = `${moment(this.headerDate).format("YYYY")}-01-01`;
      const dateEnd = moment(this.headerDate).add(1, 'days').format("YYYY-MM-DD");
      const postId = this.postId;

      const conditions = []
      conditions.push({key: dateTarget, operator: '>=', value: dateBegin})
      conditions.push({key: dateTarget, operator: '<', value: dateEnd})
      conditions.push({key: 'body.stdInfo.field_name', operator: '=', value: this.form.stdInfo.field_name})

      if (postId) {
        conditions.push({key: 'id', operator: '!=', value: postId})
      }

      if (JSON.stringify(this.oldConditions) === JSON.stringify(conditions)) return;
      this.oldConditions = JSON.parse(JSON.stringify(conditions));
      await this.$store.dispatch("board/LOAD_POST_LIST", {
        projectId,
        boardId,
        page,
        perPage,
        conditions
      });

      this.oldDataSetting();
    },
    oldDataSetting() {
      if (this.postList.length > 0) {
        const _prevDatas = [];
        const _todayDatas = [];
        this.postList.map((post) => {
          const today = moment(this.form.headerDate).format("yyyy-MM-DD");
          const headerDate = moment(post.headerDate).format("yyyy-MM-DD");
          if (post.tmbList && post.tmbList.length > 0) {
            post.tmbList.map((item) => {
              if (headerDate === today) {
                const _dataIndex = _todayDatas.findIndex((e) => e.type === item.input1_1);
                if (_dataIndex === -1) _todayDatas.push({ type: item.input1_1, value: Number(item.input3) });
                else _todayDatas[_dataIndex].value += Number(item.input3);
              } else {
                const _dataIndex = _prevDatas.findIndex((e) => e.type === item.input1_1);
                if (_dataIndex === -1) _prevDatas.push({ type: item.input1_1, value: Number(item.input3) });
                else _prevDatas[_dataIndex].value += Number(item.input3);
              }
            });
          }
        });
        this.prevTmbOption = _prevDatas;
        this.todayTmbOption = _todayDatas;
      } else {
        this.prevTmbOption = [];
        this.todayTmbOption = [];
      }
    },
    getContent(data) {
      if (data.post_content) {
        const content = JSON.parse(data.post_content);
        return content.body;
      }
    },
    onChangeDate() {
      this.form.tmbList = [];
      this.loadList();
    }
  },
};
</script>

<style scoped lang="scss"></style>
